<script>
    import gsap from 'gsap';
    import {onMount} from "svelte";
    import {labels, mainTimeline} from "../../timelines/main-timeline";

    const inTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    const {magnifyingGlassStart, magnifyingGlassEnd} = labels;

    const animationValues = {
        y: 500,
        rotate: -55,
        duration: 2,
        ease: 'in-out',
        opacity: 0,
    };

    onMount(() => {

        inTimeline.fromTo('.magnifying-glass', {...animationValues}, {
            y: 0,
            rotate: -15,
            opacity: 1,
        });
        outTimeline.to('.magnifying-glass', {...animationValues, duration: 1});

        mainTimeline.add(inTimeline, magnifyingGlassStart);
        mainTimeline.add(outTimeline, magnifyingGlassEnd);
    });

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 465.77 449.85" width="600" x=675 y=275 overflow="visible">
    <g class="magnifying-glass">
        <circle class="cls-1" cx="184.12" cy="184.12" r="149.62"/>
        <path class="cls-1" d="M98.17,104.59c21.39-23.11,51.98-37.57,85.95-37.57"/>
        <line class="cls-1" x1="323.14" y1="304.97" x2="464.77" y2="448.85"/>
        <circle class="cls-1" cx="184.12" cy="184.12" r="183.12"/>
    </g>
</svg>

<style>
    .cls-1 {
        fill: none;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2px;
    }
</style>